import { useMemo } from "react";

import styled from "styled-components";

import { useHelpBeaconIsOpen } from "Flocknote/stateHooks";

import { useEffectiveIsExpanded, useIsFullScreen } from "NavBar/stateHooks";

const CloseBackground = () => {
  const isFullScreen = useIsFullScreen();

  const [helpBeaconIsOpen] = useHelpBeaconIsOpen();
  const [isExpanded, setIsExpanded] = useEffectiveIsExpanded();

  const showBackground = useMemo(
    () => isFullScreen && isExpanded,
    [isExpanded, isFullScreen]
  );

  const handleClick = () => {
    setIsExpanded(false);
    if (helpBeaconIsOpen) window.Beacon("toggle");
  };

  return <SDiv $show={showBackground} onClick={handleClick} />;
};

const showHideStyles = ({ $show }) => {
  if ($show)
    return `
    opacity: 1;
    pointer-events: auto;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
  `;
  return `
    opacity: 0;
    pointer-events: none;
  `;
};

const SDiv = styled.div`
  position: fixed;
  overflow: hidden;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2500;
  background-color: rgba(0, 0, 0, 0.6);
  ${showHideStyles}
  transition: opacity 300ms;
`;

export default CloseBackground;
